const state = {
	tablesInStore:[
	]
};

const getters = {
	getCurrentSession: (state,tableName) => {
		return state.tablesInStore[tableName]
	},
};

const actions = {
	async saveTableInStore({commit},data){

		commit('saveTable', data);
	}
};
const mutations = {
	saveTable(state, data) {

		state.tablesInStore[data.tableName] = data.columns
	},

};
export const saveTableOptions = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
